import "../Surface.css";
import { jsx } from "react/jsx-runtime";
import { ElevationWrapper } from "./internal/Elevation.js";
import { useTheme } from "./Theme/UI.js";
import "./Theme/themeUtils.js";
import "./Theme/themes.js";
const base = "Surface_base_d2796";
const css = {
  base
};
const Surface = ({ children, elevationOverride, hover }) => {
  const {
    themeSettings: { className: themeClass }
  } = useTheme();
  const classes = [css.base, themeClass];
  return /* @__PURE__ */ jsx(
    ElevationWrapper,
    {
      border: true,
      className: classes.join(" "),
      elevationOverride,
      hover,
      children
    }
  );
};
export {
  Surface as default
};
